import { iOSPushCapability, webPushCapability } from '@/Utils/WebPushUtility';

export default {
    pushCapability: iOSPushCapability() || webPushCapability(),
};